export const initColumnRefresh = (column) => {
    column.getElement().querySelectorAll('[data-refresh="column"], [data-refresh="column"] input').forEach(element => {
        element.addEventListener('change', () => {
            // Allow other settings to do their thing first so all changes are refreshed correctly
            setTimeout(() => column.refresh(), 50);
        });
    });
};
